export enum GroupedBarChartCategory {
  TitleXAverage = 'Title X Average',
  GranteeValue = 'Grantee',
}
